import { type FC } from "react";
import { Heading } from "@tennr/frontend/components/Heading";
import {
  AnimatedIcon1,
  AnimatedIcon2,
  AnimatedIcon3,
  AnimatedIcon4,
  AnimatedIcon5,
  AnimatedIcon6,
} from "@tennr/frontend/components/AnimatedIcons";
import "./FeatureListSection.css";
import { DynamicText } from "@tennr/frontend/components/DynamicText";

export const FeatureListSection: FC = () => {
  return (
    <section className="feature-list-section section-y">
      <div className="feature-list-section-content">
        <Heading
          heading={"Pre-visit processing,\noptimized"}
          title="FROM REFERRAL TO REVENUE"
          body="Shouldn't your pre-visit operations drive conversion, cut denials, and make your team happy? We think so."
          color="dark"
          variant="section"
          width={480}
        />
        <div className="items">
          <div className="item">
            <AnimatedIcon1 className="icon" width={40} height={46} />
            <DynamicText as="p" className="feature-list-section-item-text">
              Automatically classifies and routes documentation via a universal inbox for hands-off processing.
            </DynamicText>
          </div>
          <div className="item">
            <AnimatedIcon2 className="icon" width={40} height={46} />
            <DynamicText as="p" className="feature-list-section-item-text">
              Creates, updates, and modifies charts and orders across systems.
            </DynamicText>
          </div>
          <div className="item">
            <AnimatedIcon3 className="icon" width={40} height={46} />
            <DynamicText as="p" className="feature-list-section-item-text">
              Qualifies and audits patients against complex authorization criteria.
            </DynamicText>
          </div>
          <div className="item">
            <AnimatedIcon4 className="icon" width={40} height={46} />
            <DynamicText as="p" className="feature-list-section-item-text">
              Coordinates, manages, and runs eligibility checks and complex benefits investigations.
            </DynamicText>
          </div>
          <div className="item">
            <AnimatedIcon5 className="icon" width={40} height={46} />
            <DynamicText as="p" className="feature-list-section-item-text">
              Manage the complexities of your operations with the Tennr Workflow Manager.
            </DynamicText>
          </div>
          <div className="item">
            <AnimatedIcon6 className="icon" width={40} height={46} />
            <DynamicText as="p" className="feature-list-section-item-text">
              Provides visibility to providers and patients at every step.
            </DynamicText>
          </div>
        </div>
      </div>
    </section>
  );
};
